import { getPartnerAPIKey } from '~/utils/getPartnerAPIKey'

import { IFilterUsingCurrentAPIKeyParams, THistoryStorageItem } from './types'

export const filterUsingCurrentAPIKey = ({ items }: IFilterUsingCurrentAPIKeyParams): THistoryStorageItem[] => {
  const currentAPIKey = getPartnerAPIKey()

  return items.filter((i: THistoryStorageItem) => i.apiKey === currentAPIKey)
}
